export const SECU_TYPE_34A = 'SECU_TYPE_34A';
export const SECU_TYPE_STEWARD = 'SECU_TYPE_STEWARD';